import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BusinessProvider } from 'providers/context/BusinessProvider';
import { AgentProvider } from 'providers/context/AgentProvider';
import { SentryProvider } from 'providers/context/Sentry';
import BusinessContextHydrator from 'providers/BusinessContextHydrator';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <SentryProvider>
      <BusinessContextHydrator>
        <BusinessProvider>
          <AgentProvider>
            <App />
          </AgentProvider>
        </BusinessProvider>
      </BusinessContextHydrator>
    </SentryProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
